import styled from 'styled-components/macro';

const getColorOfTagByValue = (value: string): string => {
  return (
    {
      consultation: '#12B76A',
      problem: '#F04438',
      education: '#9A44EF',
      bug: '#F79009',
      lkz: '#4D525B',
      spam: '#4A0821',
      not_relevant: '#95C1F2',
    }[value] || ''
  );
};

export const Circle = styled.div<{ value: string }>`
  background-color: ${(props) => getColorOfTagByValue(props.value)};
  width: 6px;
  height: 6px;
  border-radius: 50%;
`;

export const StyledSpan = styled.span`
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`;
